/**
 * Logs a small ASCII box to the browser console at startup (commit / branch / mode).
 * Safe for production builds; only identifies the deployed revision.
 */
export function logStartupBuildBanner(opts: {
  appName: string
  commitHash: string
  branch?: string
  mode?: string
  version?: string
}): void {
  const hash = opts.commitHash.trim() || 'unknown'
  const rows: string[] = [opts.appName, `commit ${hash}`]
  const branch = opts.branch?.trim()
  if (branch && branch !== 'unknown') {
    rows.push(`branch ${branch}`)
  }
  if (opts.version) {
    rows.push(`version ${opts.version}`)
  }
  if (opts.mode) {
    rows.push(`mode ${opts.mode}`)
  }
  const innerWidth = Math.max(...rows.map(r => r.length), 12)
  const top = `┌${'─'.repeat(innerWidth + 2)}┐`
  const bottom = `└${'─'.repeat(innerWidth + 2)}┘`
  const body = rows.map(r => `│ ${r.padEnd(innerWidth)} │`)
  // Intentional dev/prod startup banner for deployed revision identification.
  // eslint-disable-next-line no-console -- startup banner only
  console.log([top, ...body, bottom].join('\n'))
}
